export function formatAmount(value: string): string {
  // Eliminar cualquier caracter que no sea dígito excepto el punto decimal
  let cleanValue = value.replace(/[^\d.]/g, '');
  
  // Asegurar que solo haya un punto decimal
  const parts = cleanValue.split('.');
  if (parts.length > 2) {
    cleanValue = parts[0] + '.' + parts.slice(1).join('');
  }
  
  // Dividir el número en parte entera y decimal
  const [integerPart, decimalPart] = cleanValue.split('.');
  
  // Formatear la parte entera con comas
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // Retornar el número formateado con la parte decimal si existe
  return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}
